import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Select, Row, Col, notification } from 'antd';
import ExitModalWrapper from './styles/exit-modal.style';
import PhoneInput from 'react-phone-input-2';
import * as TherapistActions from '../../actions/therapist';
import 'react-phone-input-2/lib/style.css';
import { baseChatURL } from '../../constants/global';

const { Option } = Select;

class ExitModal extends Component {
    constructor(props){
        super(props);
        this.state={
            phone: "",
            showVisitOverview: true
        }
        this.sendTextMessage = this.sendTextMessage.bind(this);
    }

    sendTextMessage(){
        const { dispatch, setting, therapistRoom } = this.props;
        const { currentUser } = setting;
        if(this.state.phone === ""){
            notification['error']({
                message: 'Error',
                description: 'Please enter the phone number',
            });
            return;
        }
        const data = {
            mobile: this.state.phone,
            message: "Hello, this is " + (currentUser.firstName + " " + currentUser.lastName) + ". Please join me for a secure video call at:\n" + (baseChatURL+"/videoroom/"+therapistRoom)
        }
        dispatch(TherapistActions.sendTextMessage(data));
        this.props.onCancel();
    }
    
    render() {
		const { setting, visible, onCancel,  therapistRoom } = this.props;
        const { currentUser } = setting;

        return (
        
                <Modal
                        width={445}
                        className="inviteModal"
                        overlayClassName="inviteModal1"
                        visible={visible}
                        onCancel={onCancel}
                        centered
                        footer=""
                        >
                            <ExitModalWrapper>
                         <div className="invite-form-wrapper">
                             <header>
                             <h1>Exit Video Room</h1>   
                             <h2>Are you sure you want to exit <strong>vrname's</strong> Video Room</h2>   
                             </header>
                             <div className="button-wrapper">
                             <Row type="flex" justify="center">
                                 <Col>
                                 <button className="button-action no" onClick={onCancel}>No</button>
                                 </Col>
                                 <Col>
                                 <button className="button-action yes">Yes</button>
                                 </Col>
                             </Row>
                             </div>
                         </div>
                          </ExitModalWrapper>
                 </Modal>
                     
        );
    }
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(ExitModal);
